// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".barcode-preview__container[data-v-5ce3bec8] {\n  background: #B5B5B5;\n  padding: 30px;\n}\n.barcode-preview__paper[data-v-5ce3bec8] {\n  background: #ffffff;\n  margin-bottom: 24px;\n}", ""]);
// Exports
module.exports = exports;
